














































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import Svc, {
  ProfessionRoleRow,
  RoleUserRow,
  Privilege,
  PrivilegeCatalogItem
} from "@/services/ProfessionRole";
import DataUtility from "@/services/DataUtility";
import { storePerawat } from "@/store/modules/perawat";

interface KaryawanItem {
  id: number;
  nama: string;
  profesi: string;
}

interface PrivGroup {
  grup: string;
  grup_label: string;
  actions: string[];
  items: PrivilegeCatalogItem[];
}

const GRUP_LAIN = "_lain";

@Component
export default class SuperAdminRbacPage extends Vue {
  roles: ProfessionRoleRow[] = [];
  loading = false;
  search = "";

  dialog = false;
  editing: ProfessionRoleRow | null = null;
  saving = false;
  form: any = { id: "", name: "", parent_id: null };
  err: Record<string, string[]> = {};

  catalog: PrivilegeCatalogItem[] = [];
  catalogLoading = false;
  selected: Privilege = {};
  privSearch = "";
  openPanels: number[] = [];

  rawMode = false;
  rawJson = "{}";
  rawErr = "";

  usersDialog = false;
  usersRole: ProfessionRoleRow | null = null;
  roleUsers: RoleUserRow[] = [];
  usersLoading = false;
  pickedUsers: number[] = [];
  userSearch = "";
  attaching = false;
  detachingId: number | null = null;
  karyawan: KaryawanItem[] = [];
  karyawanLoading = false;

  userHeaders = [
    { text: "Nama / NIP", value: "nama" },
    { text: "Profesi", value: "profesi" },
    { text: "Jabatan", value: "jabatan" },
    { text: "Status", value: "aktif", sortable: false },
    { text: "Aksi", value: "actions", sortable: false }
  ];

  headers = [
    { text: "ID", value: "id" },
    { text: "Nama", value: "name" },
    { text: "Parent", value: "parent_id" },
    { text: "# Domain Privilege", value: "privCount", sortable: false },
    { text: "# User", value: "userCount", sortable: false },
    { text: "Aksi", value: "actions", sortable: false }
  ];

  get parentOptions() {
    return this.roles
      .filter(r => !this.editing || r.id !== this.editing.id)
      .map(r => ({ text: `${r.id} — ${r.name}`, value: r.id }));
  }

  async mounted() {
    await Promise.all([this.load(), this.loadCatalog()]);
  }

  async load() {
    this.loading = true;
    try {
      this.roles = await Svc.list(this.search);
    } finally {
      this.loading = false;
    }
  }

  countDomains(item: ProfessionRoleRow): number {
    return item.privilege ? Object.keys(item.privilege).length : 0;
  }

  userCount(item: ProfessionRoleRow): number {
    return Number(item.users_count || 0);
  }

  get karyawanItems() {
    const held: Record<number, boolean> = {};
    this.roleUsers.forEach(u => (held[u.id] = true));
    return this.karyawan
      .filter(k => !held[k.id])
      .map(k => ({
        id: k.id,
        text: k.profesi ? `${k.nama} — ${k.profesi}` : k.nama
      }));
  }

  async openUsersDialog(item: ProfessionRoleRow) {
    this.usersRole = item;
    this.roleUsers = [];
    this.pickedUsers = [];
    this.userSearch = "";
    this.usersDialog = true;
    this.loadKaryawan();
    await this.loadRoleUsers();
  }

  async loadRoleUsers() {
    if (!this.usersRole) return;
    const roleId = this.usersRole.id;
    this.usersLoading = true;
    try {
      const rows = await Svc.users(roleId);
      if (!this.usersRole || this.usersRole.id !== roleId) return;
      this.roleUsers = rows;
    } catch (e) {
      /* pesan error ditampilkan oleh ErrorAlert */
    } finally {
      this.usersLoading = false;
    }
  }

  async loadKaryawan() {
    if (this.karyawan.length) return;
    if (storePerawat.listKaryawan.length) {
      this.karyawan = storePerawat.listKaryawan as KaryawanItem[];
      return;
    }
    this.karyawanLoading = true;
    try {
      const res = await DataUtility.getListKaryawan();
      const list = Array.isArray(res) ? res : res?.data || [];
      this.karyawan = list;
      if (list.length) storePerawat.SET_LIST_KARYAWAN_COMBO(list);
    } catch (e) {
      this.karyawan = [];
    } finally {
      this.karyawanLoading = false;
    }
  }

  syncRoleCount() {
    if (!this.usersRole) return;
    const roleId = this.usersRole.id;
    const row = this.roles.filter(r => r.id === roleId)[0];
    if (row) this.$set(row, "users_count", this.roleUsers.length);
  }

  async attachUsers() {
    if (!this.usersRole || !this.pickedUsers.length) return;
    this.attaching = true;
    try {
      await Svc.attachUsers(this.usersRole.id, this.pickedUsers);
      this.pickedUsers = [];
      await this.loadRoleUsers();
      this.syncRoleCount();
      appModule.NoticeDelay("User ditambahkan ke role");
    } catch (e) {
      /* pesan validasi ditampilkan oleh ErrorAlert */
    } finally {
      this.attaching = false;
    }
  }

  async detachUser(user: RoleUserRow) {
    if (!this.usersRole) return;
    if (!confirm(`Lepas "${user.nama}" dari role ${this.usersRole.name}?`)) return;
    this.detachingId = user.id;
    try {
      await Svc.detachUser(this.usersRole.id, user.id);
      await this.loadRoleUsers();
      this.syncRoleCount();
      appModule.NoticeDelay("User dilepas dari role");
    } catch (e) {
      /* pesan error ditampilkan oleh ErrorAlert */
    } finally {
      this.detachingId = null;
    }
  }

  normalize(priv: Privilege | null): Privilege {
    const out: Privilege = {};
    Object.keys(priv || {}).forEach(domain => {
      const acts = (priv as Privilege)[domain] || {};
      const on: Record<string, boolean> = {};
      Object.keys(acts).forEach(a => {
        if (acts[a] === true) on[a] = true;
      });
      if (Object.keys(on).length) out[domain] = on;
    });
    return out;
  }

  get groups(): PrivGroup[] {
    const byGrup: Record<string, PrivGroup> = {};
    const known: Record<string, boolean> = {};

    this.catalog.forEach(item => {
      known[item.domain] = true;
      if (!byGrup[item.grup]) {
        byGrup[item.grup] = {
          grup: item.grup,
          grup_label: item.grup_label,
          actions: [],
          items: []
        };
      }
      const g = byGrup[item.grup];
      g.items.push(item);
      item.actions.forEach(a => {
        if (g.actions.indexOf(a) === -1) g.actions.push(a);
      });
    });

    const asing = Object.keys(this.selected).filter(d => !known[d]);
    if (asing.length) {
      const g: PrivGroup = {
        grup: GRUP_LAIN,
        grup_label: "Lainnya (di luar katalog)",
        actions: [],
        items: []
      };
      asing.forEach(domain => {
        const actions = Object.keys(this.selected[domain] || {});
        g.items.push({
          domain,
          label: domain,
          grup: GRUP_LAIN,
          grup_label: g.grup_label,
          actions
        });
        actions.forEach(a => {
          if (g.actions.indexOf(a) === -1) g.actions.push(a);
        });
      });
      byGrup[GRUP_LAIN] = g;
    }

    return Object.keys(byGrup).map(k => byGrup[k]);
  }

  get filteredGroups(): PrivGroup[] {
    const q = (this.privSearch || "").trim().toLowerCase();
    if (!q) return this.groups;
    return this.groups
      .map(g => ({
        ...g,
        items: g.items.filter(
          it =>
            it.label.toLowerCase().indexOf(q) !== -1 ||
            it.domain.toLowerCase().indexOf(q) !== -1
        )
      }))
      .filter(g => g.items.length > 0);
  }

  get selectedDomainCount(): number {
    return Object.keys(this.selected).length;
  }

  get selectedActionCount(): number {
    return Object.keys(this.selected).reduce(
      (n, d) => n + Object.keys(this.selected[d]).length,
      0
    );
  }

  isChecked(domain: string, action: string): boolean {
    return this.selected[domain] ? this.selected[domain][action] === true : false;
  }

  setPriv(domain: string, action: string, on: boolean) {
    const next: Privilege = { ...this.selected };
    const acts = { ...(next[domain] || {}) };
    if (on) {
      acts[action] = true;
    } else {
      delete acts[action];
    }
    if (Object.keys(acts).length) {
      next[domain] = acts;
    } else {
      delete next[domain];
    }
    this.selected = next;
  }

  grupCount(g: PrivGroup): number {
    return g.items.filter(it => !!this.selected[it.domain]).length;
  }

  isColumnFull(g: PrivGroup, action: string): boolean {
    const eligible = g.items.filter(it => it.actions.indexOf(action) !== -1);
    return (
      eligible.length > 0 && eligible.every(it => this.isChecked(it.domain, action))
    );
  }

  toggleColumn(g: PrivGroup, action: string, on: boolean) {
    const next: Privilege = { ...this.selected };
    g.items.forEach(it => {
      if (it.actions.indexOf(action) === -1) return;
      const acts = { ...(next[it.domain] || {}) };
      if (on) {
        acts[action] = true;
      } else {
        delete acts[action];
      }
      if (Object.keys(acts).length) {
        next[it.domain] = acts;
      } else {
        delete next[it.domain];
      }
    });
    this.selected = next;
  }

  toggleRawMode() {
    if (this.rawMode) {
      try {
        this.selected = this.normalize(JSON.parse(this.rawJson || "{}"));
        this.rawErr = "";
      } catch (e) {
        this.rawErr = "JSON tidak valid";
        return;
      }
    } else {
      this.rawJson = JSON.stringify(this.selected, null, 2);
    }
    this.rawMode = !this.rawMode;
  }

  async loadCatalog() {
    if (this.catalog.length) return;
    this.catalogLoading = true;
    try {
      this.catalog = await Svc.catalog();
    } catch (e) {
      this.catalog = [];
    } finally {
      this.catalogLoading = false;
    }
  }

  async openDialog(item?: ProfessionRoleRow) {
    this.err = {};
    this.rawErr = "";
    this.rawMode = false;
    this.privSearch = "";
    await this.loadCatalog();

    if (item) {
      this.editing = item;
      this.form = { id: item.id, name: item.name, parent_id: item.parent_id };
      this.selected = this.normalize(item.privilege);
    } else {
      this.editing = null;
      this.form = { id: "", name: "", parent_id: null };
      this.selected = {};
    }
    this.rawJson = JSON.stringify(this.selected, null, 2);
    const groups = this.groups;
    const withSel = groups
      .map((g, i) => (this.grupCount(g) ? i : -1))
      .filter(i => i >= 0);
    this.openPanels = withSel.length ? withSel : groups.length ? [0] : [];
    this.dialog = true;
  }

  async save() {
    this.err = {};
    this.rawErr = "";

    let privilege: Privilege;
    if (this.rawMode) {
      try {
        privilege = this.normalize(JSON.parse(this.rawJson || "{}"));
      } catch (e) {
        this.rawErr = "JSON tidak valid";
        return;
      }
    } else {
      privilege = this.selected;
    }

    const payload: any = {
      name: this.form.name,
      parent_id: this.form.parent_id || null,
      privilege
    };
    if (!this.editing) payload.id = this.form.id;

    this.saving = true;
    try {
      if (this.editing) {
        await Svc.update(this.editing.id, payload);
      } else {
        await Svc.create(payload);
      }
      this.dialog = false;
      appModule.NoticeDelay("Role tersimpan");
      await this.load();
    } catch (e) {
      this.err = e.response?.data?.errors || {};
    } finally {
      this.saving = false;
    }
  }

  async remove(item: ProfessionRoleRow) {
    if (!confirm(`Hapus role "${item.name}" (${item.id})?`)) return;
    try {
      await Svc.remove(item.id);
      appModule.NoticeDelay("Role dihapus");
      await this.load();
    } catch (e) {
      /* pesan guard (child/user) ditampilkan oleh ErrorAlert */
    }
  }
}
